import React from "react";
import Ft1 from "../assets/Ft1.png";
import Ft2 from "../assets/Ft2.png";
import Ft3 from "../assets/Ft3.png";
import Ft4 from "../assets/Ft4.png";
import Ft5 from "../assets/Ft5.png";
import line from "../assets/line.png";
 
// FeatureItem component to display each feature with its own circle and dotted border
const FeatureItem = ({ imageSrc, title, description }) => (
  <div className="flex items-center space-x-4 relative">
    
    {/* REVISED ICON CONTAINER: Added flex-none and simplified centering classes */}
    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-lg z-10 relative flex-none">
      <img
        src={imageSrc}
        alt={title}
        // Ensure the image itself doesn't cause overflow/stretching
        className="w-10 h-10 object-contain" 
      />
      
      {/* Dotted Border: MUST ONLY use transform: scale() */}
      <div
        className="absolute inset-0 border-2 border-dotted border-purple-400 rounded-full"
        style={{
          transform: "scale(1.4)", // This scales uniformly, enforcing a perfect circle
        }}
      ></div>
    </div>
    
    <div>
      <h3 className="font-semibold text-lg text-purple-400">{title}</h3>
      <p className="text-sm text-gray-200">{description}</p>
    </div>
  </div>
);
const FeaturesTwoColumn = () => {
  const features = [
    {
      img: Ft1,
      title: "AI-Driven Innovation",
      desc: "Developing AI-powered solutions tailored to industry needs",
    },
    {
      img: Ft2,
      title: "Cutting-Edge Research",
      desc: "Continuously evolving our AI models for better efficiency",
    },
    {
      img: Ft3,
      title: "Collaborative Approach",
      desc: "Partnering with businesses to deliver impactful AI solutions",
    },
    {
      img: Ft4,
      title: "Scalable & Secure AI",
      desc: "Ensuring reliability, security, and compliance in all AI-driven operations",
    },
  ];
 
  // Pointer and line positions
  const pointerPositions = [
    { left: "70%", top: "16%" },
    { left: "93%", top: "37%" },
    { left: "96%", top: "60%" },
    { left: "79%", top: "83%" },
    { left: "0%", top: "8%" }, // New pointer 1
    { left: "0%", top: "96%" }, // New pointer 2
  ];
 
  const linePositions = [
    { top: "22%", left: "calc(32.5% + 8px)", width: "175px" }, // below pointer at 70%
    { top: "40%", left: "calc(39% + 8px)", width: "109px" }, // below pointer at 93%
    { top: "60%", left: "calc(40% + 8px)", width: "100px" }, // below pointer at 96%
    { top: "79%", left: "calc(35% + 8px)", width: "150px" }, // below pointer at 79%
  ];
 
  return (
    <div className="grid grid-cols-2 gap-8 items-center p-10 relative">
      {/* Left Column */}
      <div className="relative flex justify-center max-w-sm mx-auto">
        {/* Heading */}
        <div className="absolute left-0 top-[-10%] pl-10 flex flex-col items-start space-y-2">
          <h2 className="text-3xl font-bold flex items-center">
            <span className="text-white mr-2">What</span>
            <span className="text-white mr-2">Set</span>
            <span className="text-white mr-2">Us</span>
            <span className="text-[#00cfff]">Apart</span> {/* Space between words */}
            <span className="text-white mr-2">?</span>
          </h2>
          {/* Underline Image */}
          <div className="mt-2 w-full max-w-xs">
            <img
              src={line} // Replace with your underline image
              alt="Underline"
              className="w-full"
            />
          </div>
        </div>
 
        <img src={Ft5} alt="Left Side" className="max-w-xs h-auto" />
 
        {/* Overlay text */}
        <div className="absolute inset-0 flex flex-col items-center justify-center -translate-x-16">
  <span className="text-[#00cfff] text-5xl font-extrabold leading-none">
    AI
  </span>
  <span className="text-white text-3xl font-semibold mt-1 leading-none">
    That Delivers
  </span>
</div>

 
        {/* White pointers */}
        {pointerPositions.map((pos, i) => (
          <div
            key={i}
            className="absolute w-3 h-3 bg-white rounded-full z-20"
            style={{ left: pos.left, top: pos.top }}
          />
        ))}
      </div>
 
      {/* Right Column for Feature Items */}
      <div className="flex flex-col space-y-10 items-start max-w-md mx-auto relative">
        {/* Rendering Feature Items Separately */}
        <FeatureItem
          imageSrc={features[0].img}
          title={features[0].title}
          description={features[0].desc}
        />
        <FeatureItem
          imageSrc={features[1].img}
          title={features[1].title}
          description={features[1].desc}
        />
        <FeatureItem
          imageSrc={features[2].img}
          title={features[2].title}
          description={features[2].desc}
        />
        <FeatureItem
          imageSrc={features[3].img}
          title={features[3].title}
          description={features[3].desc}
        />
      </div>
 
      {linePositions.map((pos, i) => (
        <div
          key={i}
          className="absolute border-t-2 border-dotted border-purple-400 z-0"
          style={{
            top: pos.top,
            left: pos.left,
            width: pos.width,
          }}
        />
      ))}
    </div>
  );
};
 
export default FeaturesTwoColumn;